import React, {useState} from 'react';
import {CANDIDATE_INPUT_INFO_TYPES_OPTIONS} from "@app/constants/Common";
import Select from "react-select";
import {requestGetCandidateInputInfo} from "@app/services/CandidateService";
import {CANDIDATE_FILES} from "@app/constants/Fields";
import {cloneDeep} from 'lodash';

const CandidateInputInfoSearch = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchList, setSearchList] = useState([]);
    const [inputInfoType, setInputInfoType] = useState("");

    const {candidateId} = props.match.params

    const onChangeInputInfoType = (value) => {
        setInputInfoType(value)
    }

    const searchInputInfo = async () => {
        if (!inputInfoType || !inputInfoType.value) {
            alert("Vui lòng nhập loại dữ liệu")
            return;
        }

        setIsLoading(true)
        let params = {candidate_id: candidateId, input_type: inputInfoType.value}
        const res = await requestGetCandidateInputInfo(params);
        setIsLoading(false)
        let resContents = res.content
        let items = {}
        if (resContents && resContents.length > 0) {
            for (let i=0; i < resContents.length; i++) {
                const row = resContents[i]
                Object.keys(row).forEach(key =>{
                    if (!items[key]) {
                        items[key] = []
                    }
                    if (CANDIDATE_FILES[key]) {
                        items[key].push({
                            title: CANDIDATE_FILES[key].name,
                            values: row[key],
                            created_user: row.created_user,
                            updated_time: row.updated_date_time,
                        })
                    }
                })
            }
        }
        setSearchList(cloneDeep(items));
    }

    return (
        <div className="container-fluid">
            <div className="card card-default">
                <div className="card-header">
                    <h4 className="w-100 mb-3">Thông tin nhập liệu</h4>
                    <h5>Person ID: {candidateId}</h5>
                    <div className={'row mt-3'}>
                        <div className={"col-sm-6"}>
                            <Select options={CANDIDATE_INPUT_INFO_TYPES_OPTIONS}
                                    value={inputInfoType}
                                    onChange={value => {
                                        onChangeInputInfoType(value);
                                    }}
                            />
                        </div>
                        <span>
                        <a href='#'
                           className='btn btn-primary'
                           onClick={() => searchInputInfo()}
                           >
                            Search
                        </a>
                            </span>
                    </div>
                    {isLoading &&
                    <div className={'col-sm-12 text-center'}>
                        <div className='spinner-grow text-primary' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                    </div>
                    }
                </div>
                <div className="card-body table-responsive p-0">
                    <table
                        className='table table-hover table-bordered text-nowrap text-center'
                    >
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Trường dữ liệu</th>
                            <th>Thông tin NL</th>
                            <th>Người nhập</th>
                            <th>Ngày nhập mới nhất</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {searchList && Object.keys(searchList).map((key, index) => {
                            const items = searchList[key]
                            return items.map(item => {
                                return <tr key={`candidate_${index}`}>
                                    <td>{index + 1}</td>
                                    <td><b>{item.title}</b></td>
                                    <td>{item.values}</td>
                                    <td>{item.created_user}</td>
                                    <td>{item.updated_time}</td>
                                    <td></td>
                                </tr>
                            })
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CandidateInputInfoSearch;
